import { IGetProductsOfMonthListDTO } from '@/models/products.model';
import { TGetProductsOfMonthQuery } from '../helpers';

class GetProductsOfMonthListDTO implements IGetProductsOfMonthListDTO {
  store_ids?: string;
  category_id?: string;
  product_sku?: string;
  date_to?: string;
  date_from?: string;
  published?: '0' | '1';
  name?: string;
  limit?: number;
  page?: number;

  constructor({ store_ids, category_id, product_sku, date_to, date_from, published, page }: TGetProductsOfMonthQuery) {
    this.store_ids = store_ids;
    this.category_id = category_id;
    this.product_sku = product_sku;
    this.date_to = date_to;
    this.date_from = date_from;
    this.published = published;
    this.page = page;
  }
}

export default GetProductsOfMonthListDTO;
